import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { mockPatientAnswersLogsData } from '../mockData/patient-answers-logs-data';

const QuestionnaireApi = [rest.get(`${API_ROOT}questionnaire/:id?`, (req, res, ctx) => res(ctx.json(mockPatientAnswersLogsData)))];

export default QuestionnaireApi;
